import { Link } from 'react-router-dom';

export default function LegalPage() {
  const scrollToContact = () => {
    window.REACT_APP_NAVIGATE('/');
    setTimeout(() => {
      const element = document.getElementById('contact');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-sm z-50 border-b border-gray-200">
        <nav className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="flex items-center justify-between h-20">
            <h1>
              <Link to="/" className="flex items-center gap-3 hover:opacity-70 transition-opacity cursor-pointer">
                <img 
                  src="https://static.readdy.ai/image/dc94b4331bde31366815bfe78425789e/ee77cd5e24359f194577e6ccca300426.png" 
                  alt="Nowest ロゴ" 
                  className="h-10 w-auto object-contain"
                />
                <span className="text-2xl font-semibold text-primary">Nowest</span>
              </Link>
            </h1>
            <div className="hidden md:flex items-center space-x-10">
              <Link to="/" className="text-secondary hover:text-primary transition-colors font-medium cursor-pointer">
                トップ
              </Link>
              <Link to="/features" className="text-secondary hover:text-primary transition-colors font-medium cursor-pointer">
                特徴
              </Link>
              <Link to="/about" className="text-secondary hover:text-primary transition-colors font-medium cursor-pointer">
                会社概要
              </Link>
              <button onClick={scrollToContact} className="bg-primary text-white px-6 py-2.5 hover:bg-accent transition-colors font-medium whitespace-nowrap cursor-pointer">
                お問い合わせ
              </button>
            </div>
          </div>
        </nav>
      </header>

      {/* Hero */}
      <section className="pt-32 pb-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="flex items-center gap-2 text-sm text-secondary mb-8">
            <Link to="/" className="hover:text-primary transition-colors cursor-pointer">Top</Link>
            <span>/</span>
            <span className="text-primary">特定商取引法に基づく表記</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-primary mb-6">特定商取引法に基づく表記</h2>
          <p className="text-xl text-secondary max-w-3xl">
            特定商取引法に基づき、以下の通り表記いたします。
          </p>
        </div>
      </section>

      {/* Legal Info */}
      <section className="py-24">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          <div className="border-t border-gray-200">
            <div className="grid md:grid-cols-4 py-6 border-b border-gray-200">
              <div className="text-secondary font-medium mb-2 md:mb-0">販売者名</div>
              <div className="md:col-span-3 text-primary">今西良光</div>
            </div>
            
            <div className="grid md:grid-cols-4 py-6 border-b border-gray-200">
              <div className="text-secondary font-medium mb-2 md:mb-0">住所</div>
              <div className="md:col-span-3 text-primary">東京都大田区南千束２−２２−１３−３０３</div>
            </div>
            
            <div className="grid md:grid-cols-4 py-6 border-b border-gray-200">
              <div className="text-secondary font-medium mb-2 md:mb-0">電話番号</div>
              <div className="md:col-span-3 text-primary">090-9325-7355</div>
            </div>
            
            <div className="grid md:grid-cols-4 py-6 border-b border-gray-200">
              <div className="text-secondary font-medium mb-2 md:mb-0">メールアドレス</div>
              <div className="md:col-span-3 text-primary">
                <a href="mailto:yoshimitsu1003@gmail.com" className="hover:text-accent transition-colors cursor-pointer">
                  yoshimitsu1003@gmail.com
                </a>
              </div>
            </div>
            
            <div className="grid md:grid-cols-4 py-6 border-b border-gray-200">
              <div className="text-secondary font-medium mb-2 md:mb-0">ホームページ</div>
              <div className="md:col-span-3 text-primary">
                <a href="https://no-west.com/" target="_blank" rel="noopener noreferrer" className="hover:text-accent transition-colors cursor-pointer">
                  https://no-west.com/
                </a>
              </div>
            </div>
            
            <div className="grid md:grid-cols-4 py-6 border-b border-gray-200">
              <div className="text-secondary font-medium mb-2 md:mb-0">お支払い方法</div>
              <div className="md:col-span-3 text-primary">銀行振込　クレジットカード</div>
            </div>
            
            <div className="grid md:grid-cols-4 py-6 border-b border-gray-200">
              <div className="text-secondary font-medium mb-2 md:mb-0">販売価格</div>
              <div className="md:col-span-3 text-primary">商品申込ページに記載</div>
            </div>
            
            <div className="grid md:grid-cols-4 py-6 border-b border-gray-200">
              <div className="text-secondary font-medium mb-2 md:mb-0">商品代金以外の必要金額</div>
              <div className="md:col-span-3 text-primary">消費税 、振込の場合：振込手数料</div>
            </div>
            
            <div className="grid md:grid-cols-4 py-6 border-b border-gray-200">
              <div className="text-secondary font-medium mb-2 md:mb-0">商品のお届け方法・時期</div>
              <div className="md:col-span-3 text-primary">
                各販売ページに特段記載がない場合は、4営業日以内にメールにてダウンロードページをご案内致します。
              </div>
            </div>
            
            <div className="grid md:grid-cols-4 py-6 border-b border-gray-200">
              <div className="text-secondary font-medium mb-2 md:mb-0">お申込み有効期限</div>
              <div className="md:col-span-3 text-primary">
                お申し込み後7日以内にお願い致します。 4日以内にご入金がない場合は、キャンセルとさせて頂きます。
              </div>
            </div>
            
            <div className="grid md:grid-cols-4 py-6 border-b border-gray-200">
              <div className="text-secondary font-medium mb-2 md:mb-0">返品・不良品について</div>
              <div className="md:col-span-3 text-primary">
                返品・キャンセル・中途解約等、情報という商品特性上、原則返品・返金は承っておりません。<br />
                なお、個別契約書に別途規定がある場合は、個別契約書に従います。
              </div>
            </div>
            
            <div className="grid md:grid-cols-4 py-6 border-b border-gray-200">
              <div className="text-secondary font-medium mb-2 md:mb-0">免責事項</div>
              <div className="md:col-span-3 text-primary">
                ご購入の商品に示された表現や再現性には個人差があり、必ずしも利益や効果を保証するものではありません。
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-primary text-gray-300">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
          <div className="grid md:grid-cols-4 gap-12 mb-12">
            <div className="md:col-span-2">
              <h4 className="text-2xl font-semibold text-white mb-4">Nowest</h4>
              <p className="text-gray-400 mb-6 leading-relaxed">
                「覚えられない」を無くす。ギネス世界記録保持者が開発した独自の記憶メソッドとAIで、すべての人に学びの成功体験を提供します。
              </p>
            </div>
            <div>
              <h5 className="text-white font-semibold mb-4">サービス</h5>
              <ul className="space-y-3">
                <li><Link to="/#services" className="hover:text-white transition-colors cursor-pointer">オンラインスクール</Link></li>
                <li><Link to="/#services" className="hover:text-white transition-colors cursor-pointer">法人向け研修</Link></li>
                <li><Link to="/#services" className="hover:text-white transition-colors cursor-pointer">コンテンツ制作</Link></li>
              </ul>
            </div>
            <div>
              <h5 className="text-white font-semibold mb-4">会社情報</h5>
              <ul className="space-y-3">
                <li><Link to="/about" className="hover:text-white transition-colors cursor-pointer">会社概要</Link></li>
                <li><Link to="/features" className="hover:text-white transition-colors cursor-pointer">特徴</Link></li>
                <li><Link to="/legal" className="hover:text-white transition-colors cursor-pointer">特定商取引法</Link></li>
                <li><button onClick={scrollToContact} className="hover:text-white transition-colors cursor-pointer text-left">お問い合わせ</button></li>
              </ul>
            </div>
          </div>
          <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-500 text-sm">© 2025 Nowest,inc. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}
